module.exports = __webpack_public_path__ + "img/thin-farm-03.dd42c58c.jpg";